import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, MessageSquareX, DollarSign } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-cream relative" data-id="element-170">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-173">
            ¿Por Qué Los Agentes Te Necesitan{' '}
            <span className="text-gold italic" data-id="element-174">HOY?</span>
          </h2>
          <p className="text-lg text-gray-600" data-id="element-175">
            El dolor más grande de un agente de bienes raíces es ver cómo se le
            escapan las ventas por no contestar a tiempo. Este es el escenario
            común todos los días:
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-176">
          <motion.div variants={itemVariants} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-177">
            <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mb-6" data-id="element-178">
              <TrendingDown className="w-7 h-7 text-red-500" data-id="element-179" />
            </div>
            <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-180">$500</h3>
            <p className="text-gray-600 font-medium mb-2" data-id="element-181">
              En anuncios pagados
            </p>
            <p className="text-sm text-gray-500" data-id="element-182">
              El agente invierte dinero para recibir 40 mensajes, pero solo
              tiene tiempo de contestar 10.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-183">
            <div className="w-14 h-14 bg-orange-50 rounded-full flex items-center justify-center mb-6" data-id="element-184">
              <MessageSquareX className="w-7 h-7 text-orange-500" data-id="element-185" />
            </div>
            <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-186">30 Mensajes</h3>
            <p className="text-gray-600 font-medium mb-2" data-id="element-187">
              Perdidos con la competencia
            </p>
            <p className="text-sm text-gray-500" data-id="element-188">
              Los clientes potenciales no esperan. Si el agente tarda horas en
              responder, se van con otro.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-189">
            <div className="w-14 h-14 bg-navy/5 rounded-full flex items-center justify-center mb-6" data-id="element-190">
              <DollarSign className="w-7 h-7 text-navy" data-id="element-191" />
            </div>
            <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-192">$10,000</h3>
            <p className="text-gray-600 font-medium mb-2" data-id="element-193">
              En comisión perdida
            </p>
            <p className="text-sm text-gray-500" data-id="element-194">
              Esos mensajes sin contestar podrían haber sido una venta
              importante para el agente.
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-navy rounded-2xl p-8 md:p-12 text-center max-w-4xl mx-auto shadow-xl" data-id="element-195">
          <h3 className="text-2xl md:text-3xl font-serif text-white mb-4" data-id="element-196">
            Tú eres quien rescata ese dinero.
          </h3>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-197">
            Al contestar en menos de 10 minutos, aumentas las posibilidades de
            cerrar una venta en un 400%. Por eso, el agente no te ve como un
            gasto, sino como una inversión para ganar más.
          </p>
          <div className="mt-8 inline-flex items-center gap-3 bg-white/10 px-6 py-3 rounded-lg text-gold font-medium" data-id="element-198">
            <span className="text-xl" data-id="element-199">💡</span>
            No necesitas ser experta en leyes de casas. Solo necesitas ser
            rápida, amable y organizada.
          </div>
        </motion.div>
      </div>
    </section>;
}